// src/views/HrvShowView.tsx

// HRV展示页面

import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'

import { Global } from '../services/Global'
import { browserUtil } from '../utils/BrowserUtil'
import HrvPage from '../components/HrvPage'

class HrvShowView extends React.Component<WithTranslation> {

    state = {
        loginName: '',
        samples: {},
        screenWidth: 1200,
        screenHeight: 600,
    }

    content: any;

    onRef = (ref: any) => {
        this.content = ref
    }

    setScreenSize = () => {
        this.setState({ screenWidth: Global.windowWidth })
        this.setState({ screenHeight: window.innerHeight })
    }

    handleResize = () => {
        console.log(`屏幕尺寸改变`)
        Global.isMobile = browserUtil.checkMobile()
        if (Global.isMobile) Global.windowWidth = window.innerWidth
        this.setScreenSize()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    componentWillMount() {
        Global.isMobile = browserUtil.checkMobile()
        if (Global.isMobile) Global.windowWidth = window.innerWidth
        window.addEventListener('resize', this.handleResize)
    }

    componentDidMount() {
        this.setScreenSize()
    }

    changeLang = () => { }

    render() {
        const { t } = this.props
        return (
            <section className="body">
                <div style={{ background: 'white', width: `${this.state.screenWidth}px`, height: `${this.state.screenHeight}px`, display: 'flex', justifyContent: 'center', alignItems: 'top' }}>
                    <HrvPage trans={t} onRef={this.onRef} />
                </div>
            </section>
        )
    }

}
export const HrvShowPage = withTranslation()(HrvShowView)